import { render, staticRenderFns } from "./about.vue?vue&type=template&id=96c0458e&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96c0458e')) {
      api.createRecord('96c0458e', component.options)
    } else {
      api.reload('96c0458e', component.options)
    }
    module.hot.accept("./about.vue?vue&type=template&id=96c0458e&", function () {
      api.rerender('96c0458e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/about.vue"
export default component.exports